import { Types } from '@grandvisionhq/graphql';
import { getLiteralText } from './get-literal-text.js';

const formatOptIns = (intl, formData, optIns, consents, groupedOptins = {})=>{
    var ref, ref1;
    // We need to map over the optins and consents and reformat it to also send the children/nested opt-ins.
    const allOptIns = [
        ...optIns.map((optIn)=>{
            return [
                optIn,
                ...(ref = optIn === null || optIn === void 0 ? void 0 : optIn.children) !== null && ref !== void 0 ? ref : []
            ];
        }),
        ...consents.map((consent)=>{
            return [
                ...(ref1 = consent === null || consent === void 0 ? void 0 : consent.children) !== null && ref1 !== void 0 ? ref1 : []
            ];
        }), 
    ].flatMap((optIn)=>optIn
    ).filter((optIn)=>!optIn.doNotSubmit
    );
    var ref2;
    const singleOptins = allOptIns.filter((optIn)=>!groupedOptins.hasOwnProperty(optIn.value)
    ).map((optIn)=>{
        return {
            id: optIn.value,
            value: (formData === null || formData === void 0 ? void 0 : formData[optIn.value]) === 'true',
            uiType: Types.UIType.CHECKBOX,
            literalText: intl.getFormattedLabel((ref2 = getLiteralText(optIn.value, optIns)) !== null && ref2 !== void 0 ? ref2 : '', {
                parseHTML: false,
                parseLink: true
            })
        };
    });
    var ref3;
    const groupedOptinsArray = Object.entries(groupedOptins).flatMap(([groupKey, ids])=>{
        return ids.map((id)=>{
            return {
                id,
                value: (formData === null || formData === void 0 ? void 0 : formData[groupKey]) === 'true',
                uiType: Types.UIType.CHECKBOX,
                literalText: intl.getFormattedLabel((ref3 = getLiteralText(groupKey, optIns)) !== null && ref3 !== void 0 ? ref3 : '', {
                    parseHTML: false,
                    parseLink: true
                })
            };
        });
    });
    return [
        ...singleOptins,
        ...groupedOptinsArray
    ];
};

export { formatOptIns };
//# sourceMappingURL=format-optins.js.map
